let images = {};

// there are 18 holes in Golf course so we loop 18 times
for (let i = 1; i < 19; i++) {
    images[i] = require(`./flag-${i}.gif`).default
}

export default images;